import UserLayout from '../components/UserLayout';

export default function UserTraining() {
    return (
        <UserLayout title="Training">
            <p>Training materials and tutorials.</p>
        </UserLayout>
    );
}
